// src/generated/playerError.ts
var Message = {
  // DRM Errors
  1e4: "Gesch\xFCtzter Inhalt kann nicht wiedergegeben werden. Inhalt neu laden oder ein anderes Ger\xE4t verwenden.",
  11e3: "Authentifizierung fehlgeschlagen. Erneut anmelden und Inhalt neu starten.",
  11200: "Zugriffsrechte fehlen. Erneut anmelden und Inhalt neu starten.",
  11210: "Zugriffsrecht f\xFCr Bezahlinhalte fehlt. Erneut anmelden und Inhalt neu starten.",
  12100: "Dieser Inhalt ist im Land nicht verf\xFCgbar. Verbindung pr\xFCfen und VPN oder Proxy deaktivieren.",
  12110: "VPN oder Proxy erkannt. VPN oder Proxy deaktivieren und Inhalt neu starten.",
  12300: "Ger\xE4t erf\xFCllt die Anforderungen f\xFCr den Kopierschutz nicht (HDCP). Anderes Ger\xE4t, Kabel oder Browser verwenden.",
  12400: "Ger\xE4t erf\xFCllt die Anforderungen f\xFCr den Kopierschutz nicht (Ger\xE4t wird von Widevine nicht unterst\xFCtzt). Anderes Ger\xE4t oder Browser verwenden.",
  // Content Errors
  2e4: "Inhalt nicht verf\xFCgbar. Anderen Titel ausw\xE4hlen oder sp\xE4ter erneut versuchen.",
  // Client Errors
  3e4: "Inhalt kann nicht abgespielt werden. Inhalt neu laden oder anderes Ger\xE4t verwenden.",
  30100: "Inhalt kann nicht abgespielt werden. Anderes Ger\xE4t oder Browser verwenden.",
  31e3: "Netzwerkproblem. Internetverbindung \xFCberpr\xFCfen und erneut versuchen.",
  32e3: "Inhalt kann nicht abgespielt werden.",
  32100: "Ger\xE4t erf\xFCllt die Anforderungen f\xFCr den Kopierschutz nicht. Anderes Ger\xE4t oder Browser verwenden.",
  32200: "Ger\xE4t erf\xFCllt die Anforderungen f\xFCr den Stream nicht. Ger\xE4t oder Browser wechseln.",
  33100: "Maximale Anzahl gleichzeitiger Wiedergaben erreicht. Wiedergabe auf einem anderen Ger\xE4t beenden und erneut versuchen.",
  34e3: "Player-Konfigurationsproblem. Support kontaktieren.",
  34100: "Werbeblocker erkannt. Bitte deaktivieren und Inhalt neu laden.",
  35430: "Wiedergabe wegen Energiesparmodus abgebrochen. Inhalt neu laden.",
  // Dependency Errors
  4e4: "Inhalt kann nicht abgespielt werden. Sp\xE4ter erneut versuchen.",
  41800: "Inhalt konnte nicht geladen werden.\n\nPr\xFCfe die Internetverbindung und versuche, den Inhalt erneut zu laden.",
  42800: "Player-Konfigurationsproblem. Support kontaktieren.",
  // Player Errors
  5e4: "Player kann nicht geladen werden. Support kontaktieren.",
  59e3: "Inhalt kann nicht abgespielt werden. Support kontaktieren."
};
var floorToNearest = (code, nearest = 1e3) => {
  return code - code % nearest;
};
var getMesssageForPlayerErrorCode = (code) => {
  let result = Message[code];
  if (result) {
    return result;
  }
  let message = Message[floorToNearest(code, 10)];
  if (message) {
    return message;
  }
  message = Message[floorToNearest(code, 100)];
  if (message) {
    return message;
  }
  message = Message[floorToNearest(code, 1e3)];
  if (message) {
    return message;
  }
  message = Message[floorToNearest(code, 1e4)];
  if (message) {
    return message;
  }
};
var PlayerError = {
  // DRM Errors
  FALLBACK_DRM_ERROR_10000: {
    code: 1e4,
    message: Message["10000"]
  },
  AUTHENTICATION_FAILED_11000: {
    code: 11e3,
    message: Message["11000"]
  },
  TOKEN_PROBLEM_11100: {
    code: 11100,
    message: Message["11000"]
  },
  TOKEN_INVALID_11110: {
    code: 11110,
    message: Message["11000"]
  },
  TOKEN_MISSING_11120: {
    code: 11120,
    message: Message["11000"]
  },
  PERMISSION_PROBLEM_11200: {
    code: 11200,
    message: Message["11200"]
  },
  PAY_PERMISSION_MISSING_11210: {
    code: 11210,
    message: Message["11210"]
  },
  DOWNLOAD_PERMISSION_MISSING_11220: {
    code: 11220,
    message: Message["11200"]
  },
  RIGHTS_RESTRICTIONS_NOT_MET_12000: {
    code: 12e3,
    message: Message["10000"]
  },
  HD_PERMISSION_MISSING_12010: {
    code: 12010,
    message: Message["10000"]
  },
  GEOBLOCKING_12100: {
    code: 12100,
    message: Message["12100"]
  },
  USING_OF_AN_ANONYM_PROXY_OR_VPN_12110: {
    code: 12110,
    message: Message["12110"]
  },
  LOCATION_NOT_ALLOWED_12120: {
    code: 12120,
    message: Message["12100"]
  },
  HDCP_REQUIREMENT_NOT_FULFILLED_12300: {
    code: 12300,
    message: Message["12300"]
  },
  DEVICE_IS_DENYLISTED_BY_GOOGLE_FOR_WIDEVINE_12400: {
    code: 12400,
    message: Message["12400"]
  },
  LICENSE_13000: {
    code: 13e3,
    message: Message["10000"]
  },
  LICENSE_EXPIRED_13100: {
    code: 13100,
    message: Message["10000"]
  },
  LICENSE_NOT_PERSISTABLE_13200: {
    code: 13200,
    message: Message["10000"]
  },
  LICENSE_ENVIRONMENT_13300: {
    code: 13300,
    message: Message["10000"]
  },
  INVALID_MISSING_FAIRPLAY_CERTIFICATE_URL_13310: {
    code: 13310,
    message: Message["10000"]
  },
  INVALID_FAIRPLAY_CERTIFICATE_DATA_13320: {
    code: 13320,
    message: Message["10000"]
  },
  // Content Errors
  CONTENT_20000: {
    code: 2e4,
    message: Message["20000"]
  },
  MEDIA_FORMAT_UNSUPPORTED_20100: {
    code: 20100,
    message: Message["20000"]
  },
  AVAILABILITY_21000: {
    code: 21e3,
    message: Message["20000"]
  },
  CONTENT_NOT_AVAILABLE_21100: {
    code: 21100,
    message: Message["20000"]
  },
  SOURCE_MATERIAL_NOT_AVAILABLE_21110: {
    code: 21110,
    message: Message["20000"]
  },
  CONTENT_NOT_DOWNLOADABLE_21200: {
    code: 21200,
    message: Message["20000"]
  },
  // Client Errors
  CLIENT_30000: {
    code: 3e4,
    message: Message["30000"]
  },
  NO_PLAYABLE_TRACK_LEFT_30100: {
    code: 30100,
    message: Message["30100"]
  },
  NETWORK_PROBLEM_31000: {
    code: 31e3,
    message: Message["31000"]
  },
  BAD_INTERNET_CONNECTION_31110: {
    code: 31110,
    message: Message["31000"]
  },
  PLATFORM_32000: {
    code: 32e3,
    message: Message["32000"]
  },
  UNSUPPORTED_DRM_32100: {
    code: 32100,
    message: Message["32100"]
  },
  NO_DRM_OPTION_AVAILABLE_ANY_MORE_32110: {
    code: 32110,
    message: Message["32100"]
  },
  DRM_NOT_FULLY_IMPLEMENTED_32120: {
    code: 32120,
    message: Message["32100"]
  },
  UNSUPPORTED_STREAM_TECH_32200: {
    code: 32200,
    message: Message["32200"]
  },
  NO_MANIFESTS_PLAYABLE_32210: {
    code: 32210,
    message: Message["32200"]
  },
  MANIFEST_NOT_SUPPORTED_32220: {
    code: 32220,
    message: Message["32200"]
  },
  MAX_CONCURRENT_STREAMS_REACHED_33100: {
    code: 33100,
    message: Message["33100"]
  },
  PLAYERCONFIG_PROBLEM_34000: {
    code: 34e3,
    message: Message["34000"]
  },
  ADBLOCKER_DETECTED_34100: {
    code: 34100,
    message: Message["34100"]
  },
  VIDEOSOURCES_CONFIG_34200: {
    code: 34200,
    message: Message["34000"]
  },
  NO_MANIFEST_IN_CONFIG_34210: {
    code: 34210,
    message: Message["34000"]
  },
  MISSING_PLAYER_ELEMENT_OR_ID_34300: {
    code: 34300,
    message: Message["34000"]
  },
  FAULTY_ADVERTISING_ISLAND_CONFIGURED_34510: {
    code: 34510,
    message: Message["34000"]
  },
  PLAYER_ALREADY_DESTROYED_35100: {
    code: 35100,
    message: Message["30000"]
  },
  FAULTY_SETUP_FOR_NON_LINEAR_ADVERTISING_35210: {
    code: 35210,
    message: Message["30000"]
  },
  MISSING_USER_INTERACTION_35310: {
    code: 35310,
    message: Message["30000"]
  },
  OPERATION_ABORTED_35400: {
    code: 35400,
    message: Message["30000"]
  },
  OPERATION_ABORTED_PLAY_35410: {
    code: 35410,
    message: Message["30000"]
  },
  OPERATION_ABORTED_LOAD_35420: {
    code: 35420,
    message: Message["30000"]
  },
  OPERATION_ABORTED_POWER_SAVING_35430: {
    code: 35430,
    message: Message["35430"]
  },
  OPERATION_ABORTED_VIDEO_REMOVED_35440: {
    code: 35440,
    message: Message["30000"]
  },
  OPERATION_NOT_SUPPORTED_35500: {
    code: 35500,
    message: Message["30000"]
  },
  // Dependency Errors
  DEPENDENCY_40000: {
    code: 4e4,
    message: Message["40000"]
  },
  V3_UNAVAILABLE_41100: {
    code: 41100,
    message: Message["40000"]
  },
  ENTITLEMENT_UNAVAILABLE_41200: {
    code: 41200,
    message: Message["40000"]
  },
  DB_UNAVAILABLE_41300: {
    code: 41300,
    message: Message["40000"]
  },
  GOOGLE_WIDEVINE_UNAVAILABLE_41400: {
    code: 41400,
    message: Message["40000"]
  },
  MANIFEST_API_UNAVAILABLE_41500: {
    code: 41500,
    message: Message["40000"]
  },
  OTHER_UNAVAILABLE_41600: {
    code: 41600,
    message: Message["40000"]
  },
  ATV_SCHEDULER_UNAVAILABLE_41700: {
    code: 41700,
    message: Message["40000"]
  },
  STUS_UNAVAILABLE_41800: {
    code: 41800,
    message: Message["41800"]
  },
  ATV_SCHEDULER_REQUEST_FAILED_HTTP_STATUS_CODE_4XX_42700: {
    code: 42700,
    message: Message["40000"]
  },
  ATV_SCHEDULER_REQUEST_FAILED_HTTP_STATUS_CODE_5XX_42710: {
    code: 42710,
    message: Message["40000"]
  },
  STUS_RETURNS_4XX_ERROR_42800: {
    code: 42800,
    message: Message["42800"]
  },
  STUS_RETURNS_5XX_ERROR_42810: {
    code: 42810,
    message: Message["42800"]
  },
  ATV_SCHEDULER_REQUEST_TIMED_OUT_43700: {
    code: 43700,
    message: Message["40000"]
  },
  STUS_SCHEDULER_REQUEST_TIMED_OUT_43800: {
    code: 43800,
    message: Message["40000"]
  },
  // Player Errors
  INTERNAL_PLAYER_ERROR_50000: {
    code: 5e4,
    message: Message["50000"]
  },
  UNEXPECTED_EVENT_51000: {
    code: 51e3,
    message: Message["50000"]
  },
  PLAYER_DEPENDENCIES_COULD_NOT_BE_LOADED_52110: {
    code: 52110,
    message: Message["50000"]
  },
  PLAYER_DEPENDENCY_MISSING_52120: {
    code: 52120,
    message: Message["50000"]
  },
  PLAYER_DEPENDENCY_INVALID_52130: {
    code: 52130,
    message: Message["50000"]
  },
  ERROR_NOT_TREATED_59000: {
    code: 59e3,
    message: Message["59000"]
  }
};
export {
  PlayerError,
  getMesssageForPlayerErrorCode
};
